import React from 'react'
import { PlanedIcon } from './PlanedIcon'

import classes from './PlanedBadge.module.scss'

export const PlanedBadge = () => {
  return (
    <div className={classes.Container}>
      <PlanedIcon />
      <span>Planed</span>
    </div>
  )
}
